import { render, staticRenderFns } from "./EditEmployee.vue?vue&type=template&id=25b2a9fb&scoped=true"
import script from "./EditEmployee.vue?vue&type=script&lang=js"
export * from "./EditEmployee.vue?vue&type=script&lang=js"
import style0 from "./EditEmployee.vue?vue&type=style&index=0&id=25b2a9fb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../hotel-wc-product/hotel-wc/sources/client/hotel-wc-admin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25b2a9fb",
  null
  
)

export default component.exports